export default __webpack_public_path__ + "static/media/3d-character.0f0e288d.jpeg";